import React from 'react';

interface WelcomeStepProps {
  onNext: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center">

      {/* Welcome message */}
      <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
        Bienvenue sur PrestaSlot !
      </h1>

      <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 max-w-2xl">
        Vous êtes à quelques étapes de gérer vos rendez-vous comme un pro.
        <br />
        Configurez votre espace en 3 étapes simples.
      </p>

      {/* CTA Button */}
      <button
        onClick={onNext}
        className="px-8 py-4 bg-gradient-to-r from-primary to-primary-light hover:from-primary-dark hover:to-primary text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
      >
        Commencer
      </button>
    </div>
  );
};

export default WelcomeStep;
